import { render, staticRenderFns } from "./addOnlineContact.vue?vue&type=template&id=348a8489&scoped=true"
import script from "./addOnlineContact.vue?vue&type=script&lang=js"
export * from "./addOnlineContact.vue?vue&type=script&lang=js"
import style0 from "./addOnlineContact.vue?vue&type=style&index=0&id=348a8489&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348a8489",
  null
  
)

export default component.exports